export default {"src":"/_next/static/media/documentmoney.0a86cee2.svg","height":87,"width":104};